"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitSurvey = void 0;
// Messages Qualtrics Window to submit in progress responses
const submitSurvey = (closeType) => {
    const iframe = document.querySelectorAll('iframe[name*="survey-iframe"]')[0];
    if (iframe && iframe.contentWindow) {
        const data = {
            closing: true,
            closeType: closeType,
        };
        iframe.contentWindow.postMessage(data, '*');
    }
};
exports.submitSurvey = submitSurvey;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicXVhbHRyaWNzSGVscGVycy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9xdWFsdHJpY3NIZWxwZXJzLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSw0REFBNEQ7QUFDckQsTUFBTSxZQUFZLEdBQUcsQ0FBQyxTQUFpQixFQUFRLEVBQUU7SUFDcEQsTUFBTSxNQUFNLEdBQUcsUUFBUSxDQUFDLGdCQUFnQixDQUNwQywrQkFBK0IsQ0FDbEMsQ0FBQyxDQUFDLENBQXNCLENBQUM7SUFDMUIsSUFBSSxNQUFNLElBQUksTUFBTSxDQUFDLGFBQWEsRUFBRTtRQUNoQyxNQUFNLElBQUksR0FBRztZQUNULE9BQU8sRUFBRSxJQUFJO1lBQ2IsU0FBUyxFQUFFLFNBQVM7U0FDdkIsQ0FBQztRQUNGLE1BQU0sQ0FBQyxhQUFhLENBQUMsV0FBVyxDQUFDLElBQUksRUFBRSxHQUFHLENBQUMsQ0FBQztLQUMvQztBQUNMLENBQUMsQ0FBQztBQVhXLFFBQUEsWUFBWSxnQkFXdkIifQ==